import {
  Box,
  Button,
  CircularProgress,
  Fade,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import KeyboardBackspaceRoundedIcon from "@mui/icons-material/KeyboardBackspaceRounded";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import axios from "axios";
import { Url } from "../Api/Api";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

const ProfileChangeNewPassword = (props) => {
  let { email, setForgotPasswordOpen, isStudent } = props;
  const navigate = useNavigate();

  const [confirmPassword, setConfirmPassword] = useState(false);

  const [formValues, setFormValues] = useState({
    newPassword: {
      value: "",
      showPassword: false,
      error: false,
      errorMessage: "",
    },
    confirmPassword: {
      value: "",
      showPassword: false,
      error: false,
      errorMessage: "",
    },
  });

  const isEqual =
    formValues.newPassword.value === formValues.confirmPassword.value;

  const handleInputChange = (field, value) => {
    setFormValues((prevState) => ({
      ...prevState,
      [field]: {
        ...prevState[field],
        value,
        error: false, // Clear error
        errorMessage: "",
      },
    }));
  };

  const restrictCopyPast = (e) => {
    e.preventDefault();
  };

  const togglePasswordVisibility = (field) => {
    setFormValues((prevState) => ({
      ...prevState,
      [field]: {
        ...prevState[field],
        showPassword: !prevState[field].showPassword,
      },
    }));
  };

  const validatePassword = (password) => {
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/;
    return passwordRegex.test(password);
  };

  const [submitLoader, setSubmitLoader] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    let isValid = true;

    const UserUrl = isStudent ? Url.StudentNewPassword : Url.NewPassword;

    const adminInput = {
      newPassword: formValues.newPassword.value,
      oldPassword: "string",
      emailId: email,
    };
    const studentInput = {
      newPassword: formValues.newPassword.value,
      oldPassword: "string",
      studentEmail: email,
    };

    // Validate new password
    if (!formValues.newPassword.value) {
      isValid = false;
      setFormValues((prevState) => ({
        ...prevState,
        newPassword: {
          ...prevState.newPassword,
          error: true,
          errorMessage: "New password is required.",
        },
      }));
    } else if (!validatePassword(formValues.newPassword.value)) {
      isValid = false;
      setFormValues((prevState) => ({
        ...prevState,
        newPassword: {
          ...prevState.newPassword,
          error: true,
          errorMessage: "Minimum 8 characters, 1 capital, 1 number, 1 symbol.",
        },
      }));
    }

    // Validate confirm password
    if (
      formValues.confirmPassword.value !== formValues.newPassword.value ||
      !formValues.confirmPassword.value
    ) {
      isValid = false;
      setFormValues((prevState) => ({
        ...prevState,
        confirmPassword: {
          ...prevState.confirmPassword,
          error: true,
          errorMessage:
            formValues.confirmPassword.value === ""
              ? "Confirm password is required."
              : "Password does not match.",
        },
      }));
    }

    if (isValid) {
      try {
        setSubmitLoader(true);
        const response = await axios.post(
          UserUrl,
          isStudent ? studentInput : adminInput
        );

        if (response?.data?.status === "1" || response?.data?.status === "-1") {
          setSubmitLoader(false);
          await Swal.fire({
            title: response?.data?.status === "1" ? "Success" : "Warning!",
            text: response?.data?.message,
            showDenyButton: false,
            showCancelButton: false,
            iconColor: "#51b0cf",
            confirmButtonColor: "#80278C",
            icon: response?.data?.status === "1" ? "success" : "warning",
            confirmButtonText: "Ok",
            timer: 5000, // Auto-close after 5 seconds
            timerProgressBar: true, // Show progress bar
            willClose: () => {
              Swal.close();
              setForgotPasswordOpen(false);
            },
          }).then((result) => {
            if (result.isConfirmed) {
              setForgotPasswordOpen(false);
            }
          });
        }
      } catch (error) {
        Swal.fire({
          title: "Error",
          text: "Network Error. Please try Again Later.",
          showDenyButton: false,
          showCancelButton: false,
          iconColor: "#51b0cf",
          confirmButtonColor: "#80278C",
          icon: "error",
          confirmButtonText: "Close",
        });
      }
    }
  };

  return (
    <Fade in={true} timeout={800}>
      <Box
        sx={{
          width: { xs: "100%" },
          // p: { xs: 3, sm: 5 },
        }}
      >
        <Box sx={{ mb: 4, mt: 2 }}>
          <Typography
            variant="body1"
            sx={{
              color: "text.secondary",
              fontSize: { xs: "0.9rem", sm: "1rem" },
            }}
          >
            Please enter the new password
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            // minHeight: "10vh",
          }}
        >
          <Box
            sx={{
              // width: { xs: "90%", sm: "400px" },
              borderRadius: "8px",
            }}
          >
            {" "}
            <Typography component="label">New Password</Typography>
            <Box component="form">
              {/* New Password Field */}
              <TextField
                fullWidth
                size="small"
                type={formValues.newPassword.showPassword ? "text" : "password"}
                value={formValues.newPassword.value}
                onChange={(e) =>
                  handleInputChange("newPassword", e.target.value)
                }
                error={formValues.newPassword.error}
                helperText={formValues.newPassword.errorMessage}
                sx={{
                  marginBottom: "16px",

                  "& .MuiFormHelperText-root": {
                    fontWeight: 600, // Set font weight to 600
                    color: "#D32F2F",
                    marginLeft: "-0.1px",
                    fontSize: "12px",
                  },
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => togglePasswordVisibility("newPassword")}
                      >
                        {formValues.newPassword.showPassword ? (
                          <Visibility />
                        ) : (
                          <VisibilityOff />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              {/* Confirm Password Field */}
              <Typography component="label">Confirm Password</Typography>
              <TextField
                fullWidth
                size="small"
                onCut={restrictCopyPast}
                onCopy={restrictCopyPast}
                onPaste={restrictCopyPast}
                type={
                  formValues.confirmPassword.showPassword ? "text" : "password"
                }
                value={formValues.confirmPassword.value}
                onChange={(e) =>
                  handleInputChange("confirmPassword", e.target.value)
                }
                error={formValues.confirmPassword.error}
                helperText={formValues.confirmPassword.errorMessage}
                sx={{
                  marginBottom: "24px",
                  "& .MuiFormHelperText-root": {
                    fontWeight: 600, // Set font weight to 600
                    color: "#D32F2F",
                    marginLeft: "-0.1px",
                    fontSize: "12px",
                  },
                }}
                inputProps={{
                  autocomplete: "new-password",
                  form: {
                    autocomplete: "off",
                  },
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() =>
                          togglePasswordVisibility("confirmPassword")
                        }
                      >
                        {formValues.confirmPassword.showPassword ? (
                          <Visibility />
                        ) : (
                          <VisibilityOff />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              {/* Buttons */}
              <Grid
                container
                spacing={2}
                sx={{ display: "flex", justifyContent: "space-between" }}
              >
                {/* Cancel Button */}
                <Grid item xs={5}>
                  <Button
                    disabled={submitLoader}
                    variant="outlined"
                    sx={{
                      padding: { xs: "6px 23px", sm: "10px 39px" },
                      width: "100%",
                      height: { xs: "35px", sm: "41px" },
                      fontSize: { xs: "12px", sm: "15px" },
                      color: "#666666",
                      fontWeight: "400",
                      border: "1px solid rgba(17, 35, 71, 0.1)",
                      borderRadius: "5px",
                      textTransform: "none",
                    }}
                    onClick={() => {
                      setForgotPasswordOpen(false);
                    }}
                  >
                    Cancel
                  </Button>
                </Grid>

                {/* Submit Button */}
                <Grid item xs={5}>
                  <Button
                    disabled={submitLoader}
                    startIcon={
                      submitLoader && (
                        <CircularProgress size={20} color="inherit" />
                      )
                    }
                    variant="outlined"
                    type="submit"
                    sx={{
                      padding: { xs: "6px 23px", sm: "10px 39px" },
                      width: "100%",
                      height: { xs: "35px", sm: "41px" },
                      fontSize: { xs: "12px", sm: "15px" },
                      color: "#FFFFFF",
                      fontWeight: "400",
                      backgroundColor: "#4CA4D6",
                      borderRadius: "5px",
                      textTransform: "none",
                      "&:hover": {
                        backgroundColor: "#3b92be", // Darker shade on hover
                      },
                    }}
                    onClick={handleSubmit}
                  >
                    Submit
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Box>
      </Box>
    </Fade>
  );
};

export default ProfileChangeNewPassword;
